"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var base = function base(theme) {
  return /*#__PURE__*/(0, _react.css)("tbody tr{font-weight:", theme.fontWeight.normal, ";td{&:first-of-type{padding-right:", theme.spacing[5], ";}}}" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));
};

var styles = {
  base: base
};
exports.styles = styles;
//# sourceMappingURL=TableWithCheckbox.styles.js.map